import { withState as coreWithState } from '@lovejunk/core'

import SupportedAction from '../types/supported-action'
import RootState from './state'

export default coreWithState<SupportedAction, RootState>()
